import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  LayoutInterface,
  HomeInterface,
  BrandsInterface,
  ProductInterface,
} from '@interfaces/index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiJSONService {
  url: string;
  connect: any;

  constructor(private _http: HttpClient) {}

  /**
   * -------------------------------------------------------
   * @summary httpOptions
   * @description  Opciones de cabeceras HTTP
   * -------------------------------------------------------
   */
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }),
  };

  /**
   * -------------------------------------------------------
   * @summary getJSONLayout
   * @description  Consumir API - GET - LAYOUT
   * @param {string} url Url de archivo json
   * -------------------------------------------------------
   */
  getJSONLayout(url: string): Observable<any> {
    return this._http.get<LayoutInterface>(url, this.httpOptions);
  }

  /**
   * -------------------------------------------------------
   * @summary getJSONHome
   * @description  Consumir API - GET - HOME
   * @param {string} url Url de archivo json
   * -------------------------------------------------------
   */
  getJSONHome(url: string): Observable<any> {
    return this._http.get<HomeInterface>(url, this.httpOptions);
  }

  /**
   * -------------------------------------------------------
   * @summary getJSONBrands
   * @description  Consumir API - GET - BRANDS
   * @param {string} url Url de archivo json
   * -------------------------------------------------------
   */
  getJSONBrands(url: string): Observable<any> {
    return this._http.get<BrandsInterface>(url, this.httpOptions);
  }

  /**
   * -------------------------------------------------------
   * @summary getJSONProducts
   * @description  Consumir API - GET - PRODUCTS
   * @param {string} url Url de archivo json
   * -------------------------------------------------------
   */
  // Consumir API - GET - PRODUCTS
  getJSONProducts(url: string): Observable<any> {
    return this._http.get<ProductInterface>(url, this.httpOptions);
  }
}
